import Payment from './components/Payment/Payment';
import Success from './components/Success/Success';

const win: any = window;

interface Props {
    rtl: boolean;
}

function App({ rtl }: Props) {
    const codPayStatus = new URL(window.location.href).searchParams.get("codPayStatus");

    if ((codPayStatus && codPayStatus === 'success') || win['codPayStatus'] === 'success') {
        return <Success rtl={rtl} />
    } else if ((codPayStatus && codPayStatus === 'error') || win['codPayStatus'] === 'error') {
        window.location = win['errorPageURL'];
        return null;
    } else
        return <Payment rtl={rtl} />
}

export default App